import React from 'react';

import { MenuList } from '@vimeo/bokeh';

interface Props {
  childrenShowing: boolean[];
  children: React.ReactNode;
}

/**
 * Similar to how RowRenderIfSpace removes item this conversely renders a list item when we know
 * it has been removed from the row. Reliant on the childrenShowing array returned from useShouldShowChildren
 * It is important to maintain the same order of elements in both sections
 */
export const ListOverflowItems = ({ childrenShowing, children }: Props) => {
  return (
    <MenuList>
      {React.Children.map(children, (child, index) => {
        return !childrenShowing[index] ? child : null;
      })}
    </MenuList>
  );
};
